import { Navigate, Outlet, useLocation } from "react-router-dom";
import { userDetails, selectedPartnerDetails } from "./Services/authenticationService";
import { slugifyTransform } from "./Utils/Helpers";

const PartnerGuard = () => {
    const location = useLocation();

    const token = localStorage.getItem("loginDetails");

    const selectedPartner = selectedPartnerDetails();

    const partner = selectedPartner?.name
        ? slugifyTransform(selectedPartner.name)
        : "";

    const allowedPartners =
        userDetails()?.partnerDetails?.map((item) =>
            slugifyTransform(item.name)
        ) || [];

    const pathParts = location.pathname
        .split("/")
        .filter(Boolean);

    const firstPartner = pathParts[0] || "";
    const secondSegment = pathParts[1] || "";

    console.log("location:", location.pathname);
    console.log("firstPartner:", firstPartner);
    console.log("secondSegment:", secondSegment);
    console.log("selectedPartner:", partner);

    // --------------------------------------------------
    // 1. Not logged in
    // --------------------------------------------------
    if (!token) {
        return (
            <Navigate
                to="/"
                replace
                state={{ from: location }}
            />
        );
    }

    // --------------------------------------------------
    // 2. No selected partner
    // --------------------------------------------------
    if (!partner) {
        return <Navigate to="/page-not-found" replace />;
    }

    // --------------------------------------------------
    // 3. If URL is only /partner
    //
    // /rabaya-infra-developers
    //          ↓
    // /rabaya-infra-developers/home
    // --------------------------------------------------
    // if (pathParts.length === 1) {
    //     return (
    //         <Navigate
    //             to={`/${firstPartner}/home`}
    //             replace
    //             state={location.state}
    //         />
    //     );
    // }

    // --------------------------------------------------
    // 4. REMOVE SECOND PARTNER
    //
    // /rabaya-infra-developers/iifl-home-finance-limited/home
    //          ↓
    // /rabaya-infra-developers/home
    //
    // /partner/another-partner/dashboard
    //          ↓
    // /partner/dashboard
    // --------------------------------------------------
    // const secondIsPartner = allowedPartners.includes(secondSegment);

    if (
        firstPartner ===
        secondSegment
    ) {
        const remainingPath = pathParts
            .slice(2)
            .join("/");

        const cleanedPath = remainingPath
            ? `/${firstPartner}/${remainingPath}`
            : `/${firstPartner}/home`;

        return (
            <Navigate
                to={`${cleanedPath}${location.search}`}
                replace
                state={location.state}
            />
        );
    }

    // --------------------------------------------------
    // 5. First partner is the selected partner
    //
    // /rabaya-infra-developers/home
    // /rabaya-infra-developers/dashboard
    //
    // Render child route
    // --------------------------------------------------
    if (firstPartner === partner) {
      console.log('Outlet:::')
        return <Outlet />;
    }

    // --------------------------------------------------
    // 6. First partner is different from selected partner
    //
    // /wrong-partner/home
    //          ↓
    // /selected-partner/home
    // --------------------------------------------------
//     const remainingPath = pathParts
//         .slice(1)
//         .join("/");

//     const newPath = remainingPath
//         ? `/${partner}/${remainingPath}`
//         : `/${partner}/home`;
//  console.log('Outlet::33:')
//     return (
//         <Navigate
//             to={`${newPath}${location.search}`}
//             replace
//             state={location.state}
//         />
//     );
if(partner!==slugifyTransform(location.pathname.split('/')[1])){
  // 4. Fix wrong path → redirect properly
  return <Navigate to={`/${partner+location.pathname+location.search}`}  state={location.state} replace />;
}
};

export default PartnerGuard;